<a class="bar2-link" href="{{btnLink}}">
    <div [hidden]="!showGadget" class="justify-content-lg-end">
        <div class="bar-title" [ngStyle]="{'width': (width + 50) + 'px'}">
            <span translate>{{title_before}} <b>{{percentage}}%</b> {{title_after}}</span>
        </div>
        <div class="bar-wrapper">
            <div class="bar2-container row" [ngStyle]="{'width': width + 'px', 'background-color': colors[1]}">
                <div class="bar-usage" [ngStyle]="{'width': usageWidth, 'background-color': colors[0]}"></div>
            </div>
        </div>
    </div>
</a>
